<quill-editor
  (onContentChanged)="onContentChanged($event)"
  (onSelectionChanged)="onSelectionChanged($event)"
  [(ngModel)]="initialContent"
  [modules]="quillConfig"
  placeholder="Enter Text"
></quill-editor>
